export var updateUserOrgUnit = function (input) {
    throw new Error('Not implemented');
};
